import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a77755a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subheader col-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "subheader-title" }, "申請書一覧")
], -1))
const _hoisted_4 = { class: "subheader-block ml-auto demo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-xl-12" }
const _hoisted_9 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "検索条件"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_11 = { class: "panel-container show" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_13 = { class: "panel-content contents" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請番号", -1))
const _hoisted_16 = { class: "col-md-5 contCnt input-daterange input-group" }
const _hoisted_17 = {
  class: "input-daterange input-group",
  id: "datepicker-5"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text fs-xl" }, "－")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請種類", -1))
const _hoisted_20 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "ステータス", -1))
const _hoisted_23 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "承認者", -1))
const _hoisted_25 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請者", -1))
const _hoisted_28 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "対象年月", -1))
const _hoisted_30 = { class: "col-md-5 contCnt input-daterange" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-xl-12" }
const _hoisted_34 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "条件結果"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_36 = { class: "panel-container show" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_38 = { class: "panel-content" }
const _hoisted_39 = {
  key: 0,
  class: "gtablecell btnDetCell"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { key: 2 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 3 }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 4 }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { key: 5 }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { key: 6 }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { key: 7 }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { key: 8 }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { key: 9 }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { key: 10 }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { key: 11 }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { key: 12 }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  key: 1,
  class: "gtablecell"
}
const _hoisted_67 = {
  key: 2,
  class: "gtablecell"
}
const _hoisted_68 = {
  key: 3,
  class: "gtablecell"
}
const _hoisted_69 = {
  key: 4,
  class: "gtablecell"
}
const _hoisted_70 = ["innerHTML"]
const _hoisted_71 = {
  key: 5,
  class: "gtablecell"
}
const _hoisted_72 = {
  key: 6,
  class: "gtablecell"
}
const _hoisted_73 = {
  key: 7,
  class: "gtablecell"
}
const _hoisted_74 = {
  key: 8,
  class: "gtablecell"
}
const _hoisted_75 = {
  key: 9,
  class: "gtablecell"
}
const _hoisted_76 = {
  key: 10,
  class: "gtablecell"
}
const _hoisted_77 = {
  key: 11,
  class: "gtablecell"
}
const _hoisted_78 = { style: {"max-height":"65vh","overflow-y":"auto"} }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "仮払申請書", -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "時間外残業申請書", -1))
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "リモートワーク申請書", -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "出張申請書", -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "接待申請書", -1))
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "社用車使用許可申請書", -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "休暇届", -1))
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "稟議書", -1))
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "経費精算書", -1))
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "休職願", -1))
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "給与・賞与振込口座登録依頼書", -1))
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "住所変更及び通勤手当申請書", -1))
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "経費振込口座登録依頼書", -1))
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-danger-600" }, "※緑色の申請書は紙での提出が必要な申請書です", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_108 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mt_dtp4month = _resolveComponent("Mt_dtp4month")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_Mo_modal_l = _resolveComponent("Mo_modal_l")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success waves-effect waves-themed",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dl()))
        }, [
          _hoisted_5,
          _createTextVNode("Excel出力 ")
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-info waves-effect waves-themed",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal()))
        }, [
          _hoisted_6,
          _createTextVNode("追加 ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      name: "start",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.domIdStart) = $event)),
                      onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.getlist(1)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.domIdStart]
                    ]),
                    _hoisted_18,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      name: "end",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.domIdEnd) = $event)),
                      onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.getlist(1)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.domIdEnd]
                    ])
                  ])
                ]),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.opRequestType,
                    modelValue: _ctx.domReqType,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.domReqType) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.opRequsetStatus,
                    modelValue: _ctx.domReqState,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.domReqState) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ]),
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.delegate4list.items4staffsSortNum,
                    label: "c_staff_name",
                    modelValue: _ctx.domAuthorizerId,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.domAuthorizerId) = $event)),
                    reduce: (label) => label.c_staff_id
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.delegate4list.items4staffsSortNum,
                    label: "c_staff_name",
                    modelValue: _ctx.domApplicantId,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.domApplicantId) = $event)),
                    reduce: (label) => label.c_staff_id
                  }, null, 8, ["options", "modelValue", "reduce"])
                ]),
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_Mt_dtp4month, {
                    contdate: _ctx.domTargetDate,
                    "onUpdate:contdate": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.domTargetDate) = $event))
                  }, null, 8, ["contdate"])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed btn-search mx-auto",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getlist(1)))
                }, " 検索 ")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_vue_good_table, {
                mode: "remote",
                onPageChange: _ctx.onPageChange,
                onSortChange: _ctx.onSortChange,
                columns: _ctx.columns,
                rows: _ctx.delegate.items,
                "sort-options": {
                  enabled: false,
                },
                "pagination-options": {
                  perPageDropdownEnabled: false,
                  enabled: true,
                  jumpFirstOrLast: false,
                  nextLabel: '次へ',
                  prevLabel: '前へ',
                  mode: 'pages',
                  ofLabel: '/',
                  pageLabel: '',
                },
                totalRows: _ctx.delegate.pager.maxcount
              }, {
                "table-row": _withCtx((props) => [
                  (props.column.field == 'btnDet')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        (props.row.c_request_type == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-block btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_karibaraiedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_41)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Zangyoedit?id=' + props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_43)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Remoteworkedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_45)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Shutchoedit?id=' + props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_47)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 5)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Settaiedit?id=' + props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_49)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 6)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Shayoshashiyoedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_51)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 7)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Keihiseisanedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_53)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 8)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Kyukatodokeedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_55)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 9)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Ringishoedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_57)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 10)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Kyushokunegaiedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_59)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 11)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Kyuyoshoyokozatorokuedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_61)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 12)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Jushohenkotsukinteateedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_63)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 13)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Keihikozatorokuedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_65)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (props.column.field == 'c_request_type')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.cnvReqType2Name(props.formattedRow[props.column.field])), 1))
                      : (props.column.field == 'c_staff_id')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_ctx.cnvStaffId2Name(props.formattedRow[props.column.field])), 1))
                        : (props.column.field == 'c_request_datetime')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(_ctx.cnvDate(props.formattedRow[props.column.field])), 1))
                          : (props.column.field == 'c_request_status')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                _createElementVNode("div", {
                                  style: {"text-align":"center"},
                                  innerHTML: 
                        _ctx.cnvStatusNum2Name(
                          props.formattedRow[props.column.field],
                          props.formattedRow['c_request_type'],
                          props.formattedRow['c_request_1_approval_datetime']
                        )
                      
                                }, null, 8, _hoisted_70)
                              ]))
                            : (props.column.field == 'c_request_1_approval')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.cnvStaffId2Name(props.formattedRow[props.column.field])), 1))
                              : (props.column.field == 'c_request_2_approval')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.cnvStaffId2Name(props.formattedRow[props.column.field])), 1))
                                : (props.column.field == 'c_request_3_approval')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(_ctx.cnvStaffId2Name(props.formattedRow[props.column.field])), 1))
                                  : (
                      props.column.field == 'c_request_1_approval_datetime'
                    )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(_ctx.getApprovalDate(
                        props.formattedRow[props.column.field],
                        props.formattedRow["c_request_1_approval"],
                        props.formattedRow["c_request_type"]
                      )), 1))
                                    : (
                      props.column.field == 'c_request_2_approval_datetime'
                    )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(_ctx.getApprovalDate(
                        props.formattedRow[props.column.field],
                        props.formattedRow["c_request_2_approval"]
                      )), 1))
                                      : (
                      props.column.field == 'c_request_3_approval_datetime'
                    )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_ctx.getApprovalDate(
                        props.formattedRow[props.column.field],
                        props.formattedRow["c_request_3_approval"]
                      )), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(props.formattedRow[props.column.field]), 1))
                ]),
                _: 1
              }, 8, ["onPageChange", "onSortChange", "columns", "rows", "totalRows"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_l, { ref: "Mo_modal_selectType" }, {
      title: _withCtx(() => [
        _createTextVNode("申請書選択")
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push('/shinsei_karibaraiedit')))
          }, _hoisted_80),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push('/shinsei_Zangyoedit')))
          }, _hoisted_82),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$router.push('/shinsei_Remoteworkedit')))
          }, _hoisted_84),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$router.push('/shinsei_Shutchoedit')))
          }, _hoisted_86),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$router.push('/shinsei_Settaiedit')))
          }, _hoisted_88),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$router.push('/shinsei_Shayoshashiyoedit')))
          }, _hoisted_90),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$router.push('/shinsei_Kyukatodokeedit')))
          }, _hoisted_92),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$router.push('/shinsei_Ringishoedit')))
          }, _hoisted_94),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$router.push('/shinsei_Keihiseisanedit')))
          }, _hoisted_96),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-down",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$router.push('/shinsei_Kyushokunegaiedit')))
          }, _hoisted_98),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-down",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$router.push('/shinsei_Kyuyoshoyokozatorokuedit')))
          }, _hoisted_100),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-down",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$router.push('/shinsei_Jushohenkotsukinteateedit')))
          }, _hoisted_102),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-down",
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.$router.push('/shinsei_Keihikozatorokuedit')))
          }, _hoisted_104),
          _hoisted_105
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          "data-dismiss": "modal",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.closeModal()))
        }, " 閉じる ")
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_106,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_107
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("button", {
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}